import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=00b36fce&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./mobile.vue?vue&type=style&index=1&id=00b36fce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b36fce",
  null
  
)

export default component.exports